import dataSelect from "@store/dataForSelect/reducers";

import { lesson_select } from "../../configs/constants";

export default dataSelect(lesson_select);
